import { CreditCard, Shield, Slack, X } from "lucide-react";
import { focusRing } from "../ui/focusRing";

interface BottomSectionProps {
  slackOauthUrl: string;
}

export function BottomSection({ slackOauthUrl }: BottomSectionProps) {
  return (
    <>
      <section className="py-20 px-6 bg-amber-50/50 border-t border-orange-200">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4">
            Ready to get organized?
          </h2>
          <p className="text-lg text-stone-600 mb-8">
            Stop losing requests in Slack. Start tracking them.
          </p>
          <a
            href={slackOauthUrl}
            className={`inline-flex items-center gap-2 bg-brand-orange text-white px-8 py-4 rounded-full font-semibold text-xl hover:bg-brand-orange-hover transition-all shadow-lg ${focusRing}`}
          >
            <Slack className="w-5 h-5" />
            Add to Slack
          </a>
        </div>
      </section>

      <section className="px-6 pb-8 bg-amber-50/50">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-wrap justify-center gap-6 text-sm text-stone-500">
            {[
              { icon: <Shield className="w-4 h-4" />, text: "Minimal permissions" },
              { icon: <CreditCard className="w-4 h-4" />, text: "No credit card required" },
              { icon: <X className="w-4 h-4" />, text: "Uninstall anytime" },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                {item.icon}
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
